export const introductionText = `<p>
          Your renewal details are shown here and will become effective when your policy automatically renews on
          <strong>21 June 2025</strong>.
        </p>
        <p> You have the flexibility to make changes to your renewal before this date. </p>
        <p>
          Please explore the available options to you and what the impact to your premium payment and claims outcome
          could be. Any changes you make will appear in the ‘Adjusted renewal summary’, but no updates will be applied
          until you click ‘Submit’. If you don’t submit changes, your policy will renew as shown in the ‘Renewal
          summary’.
        </p>
        <p>
          <a>View current policy</a>
        </p>`;

export const renewalText = `<h3>You have chosen to make the following changes to your renewal.</h3>
<ul>
  <li>
    <strong>Increase</strong> Annual excess from <strong>$0</strong> to
    <strong>$250</strong>
  </li>
  <li>
    <strong>Increase</strong> Benefit percentage from <strong>70%</strong> to
    <strong>80%</strong>
  </li>
  <li><strong>Exclude</strong> Routine care</li>
  <li><strong>Include</strong> Booster care</li>
</ul>
    <p>
    You may be able to make other changes to your cover. Contact us on 1300 855
    663 to discuss.</p>

    <p>
      <strong
        >You’ve previously confirmed and acknowledged the following:</strong
      >
    </p>
    <ul>
      <li>
        The product you have chosen is suitable for you and your pet’s needs
      </li>
      <li>
        You have the financial means to cover any vet expenses above the benefit
        paid for accepted claims.
      </li>
      <li>
        You will pay the vet invoice in full and upfront before submitting a
        claim for eligible expenses unless you are able to pay only the ‘gap’
        only through our GapOnly® platform at the time of treatment when
        visiting a GapOnly® enabled vet.
      </li>
      <li>
        You will pay the applicable premium, which will increase at your yearly
        renewal.
      </li>
      <li>
        The product does not provide cover for your pet’s chronic pre-existing
        conditions or for general exclusions outlined in the PDS. Note that this
        applies to any optional cover you have added.
      </li>
    </ul>

    <p>
      By pressing Submit below, you understand and agree that your upcoming
      <strong> premium will decrease from $100.50 to $85.50</strong>, and your
      <strong> claim costs (for non-Routine Care claims) will decrease as
      shown in the claim example in the Adjusted renewal summary box.</strong>
    </p>
    <p>
      Once submitted, you will not be able to make any further changes to this
      renewal on the Pet Portal.
    </p>
    <p>
      Any claims examples on this page are illustrative only. Claims experience
      may vary on individual circumstances and are subject to policy terms and
      conditions.
    </p>
  </ul>
</ul>
`;

export const adjustedSummaryMock = `<p>By adjusting your cover, your annual premium will decrease by $20, and your out-of-pocket claim costs (for non-Routine Care claims) will increase from $600 to $850 as shown in the claim example above and below.<p>`;

export const options = {
  annualExcess: [
    { label: '$0', value: 0 },
    { label: '$50', value: 50 },
    { label: '$100', value: 100 },
    { label: '$150', value: 150 },
    { label: '$200', value: 200 },
    { label: '$250', value: 250 }
  ],
  benefitPercentage: [
    { label: '70%', value: 70 },
    { label: '80%', value: 80 },
    { label: '90%', value: 90 }
  ],
  routineCare: [
    { label: 'Include', value: true },
    { label: 'Exclude', value: false }
  ],
  boosterCare: [
    { label: 'Include', value: true },
    { label: 'Exclude', value: false }
  ]
};

export const response = {
  OnlineQuoteNumber: 3000227945,
  QuoteReferenceNumber: 'PI30002279458',
  StartDate: '2026-09-09T00:00:00',
  EndDate: '2027-09-09T00:00:00',
  Web: false,
  Telephone: false,
  FaceToFace: false,
  Pets: [
    {
      PetID: 228914,
      PetName: '',
      PetOrderNumber: 1,
      Partners: [
        {
          PartnerNumber: 'PIA',
          PaymentFrequencies: [
            {
              PolicyNo: null,
              PaymentFrequencyCode: 'MONTHLY',
              EndorsementId: 0
            }
          ],
          Products: [
            {
              ProductCode: 'BOCA',
              ProductName: 'Booster Care'
            },
            {
              ProductCode: 'CORE',
              ProductName: 'Core Cover'
            },
            {
              ProductCode: 'ROCA',
              ProductName: 'Routine Care'
            }
          ],
          ExcessLevels: [
            {
              ExcessCode: '4340',
              Excess: '0'
            },
            {
              ExcessCode: '4341',
              Excess: '0'
            },
            {
              ExcessCode: '4342',
              Excess: '0'
            },
            {
              ExcessCode: '4343',
              Excess: '100'
            },
            {
              ExcessCode: '4344',
              Excess: '100'
            },
            {
              ExcessCode: '4345',
              Excess: '100'
            },
            {
              ExcessCode: '4346',
              Excess: '300'
            },
            {
              ExcessCode: '4347',
              Excess: '300'
            },
            {
              ExcessCode: '4348',
              Excess: '300'
            },
            {
              ExcessCode: '4349',
              Excess: '600'
            },
            {
              ExcessCode: '4350',
              Excess: '600'
            }
          ],
          LevelsOfCover: [
            {
              LevelOfCoverCode: '4340',
              LevelOfCover: '70'
            },
            {
              LevelOfCoverCode: '4341',
              LevelOfCover: '80'
            },
            {
              LevelOfCoverCode: '4342',
              LevelOfCover: '90'
            },
            {
              LevelOfCoverCode: '4343',
              LevelOfCover: '70'
            },
            {
              LevelOfCoverCode: '4344',
              LevelOfCover: '80'
            },
            {
              LevelOfCoverCode: '4345',
              LevelOfCover: '90'
            },
            {
              LevelOfCoverCode: '4346',
              LevelOfCover: '70'
            },
            {
              LevelOfCoverCode: '4347',
              LevelOfCover: '80'
            },
            {
              LevelOfCoverCode: '4348',
              LevelOfCover: '90'
            },
            {
              LevelOfCoverCode: '4349',
              LevelOfCover: '80'
            },
            {
              LevelOfCoverCode: '4350',
              LevelOfCover: '90'
            }
          ],
          AnnualBenefitLimits: [
            {
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: '15000'
            }
          ],
          FixedTerms: [
            {
              Term: 1
            }
          ],
          Premiums: [
            {
              ProductCode: 'BOCA',
              PlanNumber: 1071,
              CombinationGroupId: 1000001,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4340',
              Excess: 0.0,
              LevelOfCoverCode: '4340',
              LevelOfCover: 70.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 110.9,
              StampDuty: 10.98,
              Gst: 11.09,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'BOCA',
              PlanNumber: 1071,
              CombinationGroupId: 1000002,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4341',
              Excess: 0.0,
              LevelOfCoverCode: '4341',
              LevelOfCover: 80.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 133.92,
              StampDuty: 13.26,
              Gst: 13.39,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'BOCA',
              PlanNumber: 1071,
              CombinationGroupId: 1000003,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4342',
              Excess: 0.0,
              LevelOfCoverCode: '4342',
              LevelOfCover: 90.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 158.83,
              StampDuty: 15.72,
              Gst: 15.88,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'BOCA',
              PlanNumber: 1071,
              CombinationGroupId: 1000004,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4343',
              Excess: 100.0,
              LevelOfCoverCode: '4343',
              LevelOfCover: 70.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 88.99,
              StampDuty: 8.81,
              Gst: 8.9,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'BOCA',
              PlanNumber: 1071,
              CombinationGroupId: 1000005,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4344',
              Excess: 100.0,
              LevelOfCoverCode: '4344',
              LevelOfCover: 80.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 107.46,
              StampDuty: 10.64,
              Gst: 10.75,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'BOCA',
              PlanNumber: 1071,
              CombinationGroupId: 1000006,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4345',
              Excess: 100.0,
              LevelOfCoverCode: '4345',
              LevelOfCover: 90.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 127.44,
              StampDuty: 12.62,
              Gst: 12.74,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'BOCA',
              PlanNumber: 1071,
              CombinationGroupId: 1000007,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4346',
              Excess: 300.0,
              LevelOfCoverCode: '4346',
              LevelOfCover: 70.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 68.16,
              StampDuty: 6.75,
              Gst: 6.82,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'BOCA',
              PlanNumber: 1071,
              CombinationGroupId: 1000008,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4347',
              Excess: 300.0,
              LevelOfCoverCode: '4347',
              LevelOfCover: 80.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 82.31,
              StampDuty: 8.15,
              Gst: 8.23,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'BOCA',
              PlanNumber: 1071,
              CombinationGroupId: 1000009,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4348',
              Excess: 300.0,
              LevelOfCoverCode: '4348',
              LevelOfCover: 90.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 97.62,
              StampDuty: 9.66,
              Gst: 9.76,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'BOCA',
              PlanNumber: 1071,
              CombinationGroupId: 1000010,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4349',
              Excess: 600.0,
              LevelOfCoverCode: '4349',
              LevelOfCover: 80.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 66.43,
              StampDuty: 6.58,
              Gst: 6.64,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'BOCA',
              PlanNumber: 1071,
              CombinationGroupId: 1000011,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4350',
              Excess: 600.0,
              LevelOfCoverCode: '4350',
              LevelOfCover: 90.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 78.78,
              StampDuty: 7.8,
              Gst: 7.88,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'CORE',
              PlanNumber: 1071,
              CombinationGroupId: 2000001,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4340',
              Excess: 0.0,
              LevelOfCoverCode: '4340',
              LevelOfCover: 70.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 546.29,
              StampDuty: 54.08,
              Gst: 54.63,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [
                {
                  LoadingCode: 'ADMINFEE',
                  LoadingName: 'Admin Fee $2/instalment',
                  LoadingBase: 20.02,
                  LoadingStampDuty: 1.98,
                  LoadingGst: 2.0,
                  LoadingNo: 21666,
                  WebDisplayValue: false,
                  PremiumFreeValue: 0.0
                }
              ],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'CORE',
              PlanNumber: 1071,
              CombinationGroupId: 2000002,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4341',
              Excess: 0.0,
              LevelOfCoverCode: '4341',
              LevelOfCover: 80.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 659.69,
              StampDuty: 65.31,
              Gst: 65.97,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [
                {
                  LoadingCode: 'ADMINFEE',
                  LoadingName: 'Admin Fee $2/instalment',
                  LoadingBase: 20.02,
                  LoadingStampDuty: 1.98,
                  LoadingGst: 2.0,
                  LoadingNo: 21666,
                  WebDisplayValue: false,
                  PremiumFreeValue: 0.0
                }
              ],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'CORE',
              PlanNumber: 1071,
              CombinationGroupId: 2000003,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4342',
              Excess: 0.0,
              LevelOfCoverCode: '4342',
              LevelOfCover: 90.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 782.37,
              StampDuty: 77.45,
              Gst: 78.24,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [
                {
                  LoadingCode: 'ADMINFEE',
                  LoadingName: 'Admin Fee $2/instalment',
                  LoadingBase: 20.02,
                  LoadingStampDuty: 1.98,
                  LoadingGst: 2.0,
                  LoadingNo: 21666,
                  WebDisplayValue: false,
                  PremiumFreeValue: 0.0
                }
              ],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'CORE',
              PlanNumber: 1071,
              CombinationGroupId: 2000004,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4343',
              Excess: 100.0,
              LevelOfCoverCode: '4343',
              LevelOfCover: 70.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 438.34,
              StampDuty: 43.4,
              Gst: 43.83,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [
                {
                  LoadingCode: 'ADMINFEE',
                  LoadingName: 'Admin Fee $2/instalment',
                  LoadingBase: 20.02,
                  LoadingStampDuty: 1.98,
                  LoadingGst: 2.0,
                  LoadingNo: 21666,
                  WebDisplayValue: false,
                  PremiumFreeValue: 0.0
                }
              ],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'CORE',
              PlanNumber: 1071,
              CombinationGroupId: 2000005,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4344',
              Excess: 100.0,
              LevelOfCoverCode: '4344',
              LevelOfCover: 80.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 529.33,
              StampDuty: 52.4,
              Gst: 52.93,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [
                {
                  LoadingCode: 'ADMINFEE',
                  LoadingName: 'Admin Fee $2/instalment',
                  LoadingBase: 20.02,
                  LoadingStampDuty: 1.98,
                  LoadingGst: 2.0,
                  LoadingNo: 21666,
                  WebDisplayValue: false,
                  PremiumFreeValue: 0.0
                }
              ],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'CORE',
              PlanNumber: 1071,
              CombinationGroupId: 2000006,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4345',
              Excess: 100.0,
              LevelOfCoverCode: '4345',
              LevelOfCover: 90.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 627.77,
              StampDuty: 62.15,
              Gst: 62.78,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [
                {
                  LoadingCode: 'ADMINFEE',
                  LoadingName: 'Admin Fee $2/instalment',
                  LoadingBase: 20.02,
                  LoadingStampDuty: 1.98,
                  LoadingGst: 2.0,
                  LoadingNo: 21666,
                  WebDisplayValue: false,
                  PremiumFreeValue: 0.0
                }
              ],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'CORE',
              PlanNumber: 1071,
              CombinationGroupId: 2000007,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4346',
              Excess: 300.0,
              LevelOfCoverCode: '4346',
              LevelOfCover: 70.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 335.77,
              StampDuty: 33.24,
              Gst: 33.58,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [
                {
                  LoadingCode: 'ADMINFEE',
                  LoadingName: 'Admin Fee $2/instalment',
                  LoadingBase: 20.02,
                  LoadingStampDuty: 1.98,
                  LoadingGst: 2.0,
                  LoadingNo: 21666,
                  WebDisplayValue: false,
                  PremiumFreeValue: 0.0
                }
              ],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'CORE',
              PlanNumber: 1071,
              CombinationGroupId: 2000008,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4347',
              Excess: 300.0,
              LevelOfCoverCode: '4347',
              LevelOfCover: 80.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 405.47,
              StampDuty: 40.14,
              Gst: 40.55,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [
                {
                  LoadingCode: 'ADMINFEE',
                  LoadingName: 'Admin Fee $2/instalment',
                  LoadingBase: 20.02,
                  LoadingStampDuty: 1.98,
                  LoadingGst: 2.0,
                  LoadingNo: 21666,
                  WebDisplayValue: false,
                  PremiumFreeValue: 0.0
                }
              ],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'CORE',
              PlanNumber: 1071,
              CombinationGroupId: 2000009,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4348',
              Excess: 300.0,
              LevelOfCoverCode: '4348',
              LevelOfCover: 90.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 480.87,
              StampDuty: 47.61,
              Gst: 48.09,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [
                {
                  LoadingCode: 'ADMINFEE',
                  LoadingName: 'Admin Fee $2/instalment',
                  LoadingBase: 20.02,
                  LoadingStampDuty: 1.98,
                  LoadingGst: 2.0,
                  LoadingNo: 21666,
                  WebDisplayValue: false,
                  PremiumFreeValue: 0.0
                }
              ],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'CORE',
              PlanNumber: 1071,
              CombinationGroupId: 2000010,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4349',
              Excess: 600.0,
              LevelOfCoverCode: '4349',
              LevelOfCover: 80.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 327.22,
              StampDuty: 32.39,
              Gst: 32.72,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [
                {
                  LoadingCode: 'ADMINFEE',
                  LoadingName: 'Admin Fee $2/instalment',
                  LoadingBase: 20.02,
                  LoadingStampDuty: 1.98,
                  LoadingGst: 2.0,
                  LoadingNo: 21666,
                  WebDisplayValue: false,
                  PremiumFreeValue: 0.0
                }
              ],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'CORE',
              PlanNumber: 1071,
              CombinationGroupId: 2000011,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4350',
              Excess: 600.0,
              LevelOfCoverCode: '4350',
              LevelOfCover: 90.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 388.07,
              StampDuty: 38.42,
              Gst: 38.81,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [
                {
                  LoadingCode: 'ADMINFEE',
                  LoadingName: 'Admin Fee $2/instalment',
                  LoadingBase: 20.02,
                  LoadingStampDuty: 1.98,
                  LoadingGst: 2.0,
                  LoadingNo: 21666,
                  WebDisplayValue: false,
                  PremiumFreeValue: 0.0
                }
              ],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'ROCA',
              PlanNumber: 1071,
              CombinationGroupId: 3000001,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4340',
              Excess: 0.0,
              LevelOfCoverCode: '4340',
              LevelOfCover: 70.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 132.23,
              StampDuty: 13.09,
              Gst: 13.22,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'ROCA',
              PlanNumber: 1071,
              CombinationGroupId: 3000002,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4341',
              Excess: 0.0,
              LevelOfCoverCode: '4341',
              LevelOfCover: 80.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 132.23,
              StampDuty: 13.09,
              Gst: 13.22,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'ROCA',
              PlanNumber: 1071,
              CombinationGroupId: 3000003,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4342',
              Excess: 0.0,
              LevelOfCoverCode: '4342',
              LevelOfCover: 90.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 132.23,
              StampDuty: 13.09,
              Gst: 13.22,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'ROCA',
              PlanNumber: 1071,
              CombinationGroupId: 3000004,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4343',
              Excess: 100.0,
              LevelOfCoverCode: '4343',
              LevelOfCover: 70.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 132.23,
              StampDuty: 13.09,
              Gst: 13.22,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'ROCA',
              PlanNumber: 1071,
              CombinationGroupId: 3000005,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4344',
              Excess: 100.0,
              LevelOfCoverCode: '4344',
              LevelOfCover: 80.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 132.23,
              StampDuty: 13.09,
              Gst: 13.22,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'ROCA',
              PlanNumber: 1071,
              CombinationGroupId: 3000006,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4345',
              Excess: 100.0,
              LevelOfCoverCode: '4345',
              LevelOfCover: 90.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 132.23,
              StampDuty: 13.09,
              Gst: 13.22,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'ROCA',
              PlanNumber: 1071,
              CombinationGroupId: 3000007,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4346',
              Excess: 300.0,
              LevelOfCoverCode: '4346',
              LevelOfCover: 70.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 132.23,
              StampDuty: 13.09,
              Gst: 13.22,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'ROCA',
              PlanNumber: 1071,
              CombinationGroupId: 3000008,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4347',
              Excess: 300.0,
              LevelOfCoverCode: '4347',
              LevelOfCover: 80.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 132.23,
              StampDuty: 13.09,
              Gst: 13.22,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'ROCA',
              PlanNumber: 1071,
              CombinationGroupId: 3000009,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4348',
              Excess: 300.0,
              LevelOfCoverCode: '4348',
              LevelOfCover: 90.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 132.23,
              StampDuty: 13.09,
              Gst: 13.22,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'ROCA',
              PlanNumber: 1071,
              CombinationGroupId: 3000010,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4349',
              Excess: 600.0,
              LevelOfCoverCode: '4349',
              LevelOfCover: 80.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 132.23,
              StampDuty: 13.09,
              Gst: 13.22,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            },
            {
              ProductCode: 'ROCA',
              PlanNumber: 1071,
              CombinationGroupId: 3000011,
              PaymentFrequencyCode: 'MONTHLY',
              ExcessCode: '4350',
              Excess: 600.0,
              LevelOfCoverCode: '4350',
              LevelOfCover: 90.0,
              AnnualBenefitLimitCode: '19772',
              AnnualBenefitLimit: 15000.0,
              BasePremium: 132.23,
              StampDuty: 13.09,
              Gst: 13.22,
              FixedTerm: 1,
              EndDate: '0001-01-01T00:00:00',
              CoverPeriod: null,
              IsBenefitSchedulePlan: 0,
              Loadings: [],
              OptionalCovers: [],
              Breakdown: null
            }
          ]
        }
      ]
    }
  ]
};
